import { Vec2 } from "../models/SyntheticMap";
import { Visual } from "../models/Visual";
import { BaseVisual } from "./BaseVisual";
import * as THREE from "three";

export interface C4VisualData extends Visual {
  floorId: string; // The floor this C4 is attached to
}

export class C4Visual extends BaseVisual implements C4VisualData {
  floorId: string = '';
  constructor() {
    super();
  }
  
  public getType(): string {
    return 'C4Visual';
  }

  public container = new THREE.Group();
  protected async buildObj(): Promise<THREE.Object3D> {
    this.updateObj(); // Initialize the floor object
    return this.container;
  }
  public updateObj(): void {
    this.container.clear();
    const launcherCount: Vec2 = { x: 6, y: 6 };
    const tubeDiameter = 0.25;
    const tubeLength = 1;
    const offset: Vec2 = {
      x: -3 - launcherCount.x / 2 * -tubeDiameter,
      y: launcherCount.y / 2 * -tubeDiameter
    };
    const geometry = new THREE.CylinderGeometry(tubeDiameter / 2, tubeDiameter / 2, 1, 16);
    const material = new THREE.MeshStandardMaterial({
      color: 0x858585,
      metalness: 0.5,
      roughness: 0.75
    });
    for (let row = 0; row < launcherCount.x; row++) {
      for (let column = 0; column < launcherCount.y; column++) {
        const cylinder = new THREE.Mesh(geometry, material);
        cylinder.position.set(
          offset.x + row * tubeDiameter + tubeDiameter / 2,
          offset.y + column * tubeDiameter + tubeDiameter / 2,
          tubeLength / 2
        );
        cylinder.rotation.x = Math.PI / 2;
        this.container.add(cylinder);
      }
    }
  }

  public render(delta: number): void {
    if (this.agent && this.agent.render(delta)) {
      return;
    }
  }

  public createDataTemplate(): Visual {
    const data: C4VisualData = {
      type: this.getType(),
      _id: this._id,
      id: this.id,
      position: this.position,
      rotation: this.rotation,
      orgId: this.orgId,
      siteAnchorId: this.siteAnchorId,
      location: this.location,
      floorId: this.floorId,
    };
    return data;
  }

}